import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { captureEvent } from '../utils/posthog';
import { EVENTS, PROPERTIES } from '../utils/analytics';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId, isCTA = false) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);

      // Track navigation click
      if (isCTA) {
        captureEvent(EVENTS.CTA_BUTTON_CLICKED, {
          [PROPERTIES.NAVIGATION_TARGET]: sectionId,
          [PROPERTIES.CTA_LOCATION]: 'header',
          [PROPERTIES.CTA_TEXT]: 'Get Early Access',
          is_mobile: window.innerWidth < 768,
        });
      } else {
        captureEvent(EVENTS.HEADER_NAVIGATION_CLICKED, {
          [PROPERTIES.NAVIGATION_TARGET]: sectionId,
          is_mobile: window.innerWidth < 768,
        });
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-16 h-16 flex items-center justify-center p-0.5">
              <img 
                src={require('../assets/images/purfectpix-logo.png')} 
                alt="Snapcom Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-2xl font-bold text-yellow-500">Snapcom</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-300 hover:text-yellow-500 transition-colors duration-200"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-300 hover:text-yellow-500 transition-colors duration-200"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-gray-300 hover:text-yellow-500 transition-colors duration-200"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-gray-300 hover:text-yellow-500 transition-colors duration-200"
            >
              FAQ
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('waitlist', true)}
              className="btn-primary bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6"
            >
              Get Early Access
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 glass rounded-lg">
            <nav className="flex flex-col space-y-4 p-4">
              <button
                onClick={() => scrollToSection('features')}
                className="text-gray-300 hover:text-yellow-500 transition-colors duration-200 text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-300 hover:text-yellow-500 transition-colors duration-200 text-left"
              >
                How It Works
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-gray-300 hover:text-yellow-500 transition-colors duration-200 text-left"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-gray-300 hover:text-yellow-500 transition-colors duration-200 text-left"
              >
                FAQ
              </button>
              <Button
                onClick={() => scrollToSection('waitlist', true)}
                className="btn-primary bg-yellow-500 hover:bg-yellow-600 text-black font-semibold w-full"
              >
                Get Early Access
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};